import { Home, BarChart3, BookOpen, User } from 'lucide-react';
import { NavLink } from '@/components/NavLink';

export default function Navigation() {
  const navItems = [
    { icon: Home, label: 'Home', path: '/dashboard' },
    { icon: BarChart3, label: 'Analytics', path: '/analytics' },
    { icon: BookOpen, label: 'Content', path: '/content' },
    { icon: User, label: 'Profile', path: '/profile' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 px-6 pb-[max(1rem,env(safe-area-inset-bottom))] pt-2 pointer-events-none">
      <div className="max-w-md mx-auto relative pointer-events-auto">
        <div className="flex items-center justify-around bg-card rounded-full shadow-lg border border-border h-14 px-4 overflow-visible">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className="flex-1 flex items-center justify-center overflow-visible"
              activeClassName=""
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              {({ isActive }) =>
                isActive ? (
                  <div className="relative -mt-6 flex items-center justify-center">
                    <div className="absolute inset-0 m-auto w-16 h-16 rounded-full bg-card border border-border shadow-lg" />
                    <div className="relative w-14 h-14 rounded-full bg-lime-500 flex items-center justify-center shadow-md">
                      <item.icon className="w-6 h-6 text-deep-800" strokeWidth={2.5} />
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center justify-center w-10 h-10 text-deep-700">
                    <item.icon className="w-5 h-5" strokeWidth={2} />
                  </div>
                )
              }
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
}
